export default __webpack_public_path__ + "static/media/pexels-mikhail-nilov-8943075.23286d8c.jpg";